import { render, staticRenderFns } from "./logsViews.vue?vue&type=template&id=3b6424c0"
import script from "./logsViews.vue?vue&type=script&lang=js"
export * from "./logsViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports